import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import {
  COLOR_LIGHT_BLUE,
  COLOR_PRIMARY_BACKGROUND,
} from "shared/theme/colors";

export const StyledInfoContainer = styled(Typography)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 8px;
  background-color: ${COLOR_PRIMARY_BACKGROUND};
  color: ${COLOR_LIGHT_BLUE};
`;

export const StyledInfoIconContainer = styled.div`
  display: flex;
  margin-right: 8px;
`;
